import React from 'react'
import PasswordFieldContainer from './../../shared/components/fields/passwordField/PasswordFieldContainer';
import {PropTypes} from 'prop-types';
import ObjectUtils from '../../shared/utils/ObjectUtils';
import forwardButtonImg from './../../shared/img/forward-button.svg'
import {I18n} from 'react-redux-i18n';

const ResetPassword = ({
    className,
    password,
    repeatPassword,
    handlePasswordDataChanged,
    handleFieldBlur,
    handleCollapseResetPasswordClicked = () => { },
    handleSubmit,
    loading
}) => {

    const disabled = ObjectUtils.isNilOrEmpty(password.value) || ObjectUtils.isNilOrEmpty(repeatPassword.value) ||
        !ObjectUtils.isNilOrEmpty(password.error) || !ObjectUtils.isNilOrEmpty(repeatPassword.error);

    return <div className={className}>
        <div className="login-form login-password-form" style={{ color: '#919191', paddingTop: '7vh' }}>
            <p style={{ fontSize: '1.5rem', fontWeight: '600' }}>{I18n.t('auth.resetPassword.title')}</p>
            <p style={{ paddingTop: '1vh', marginBottom: '5vh', fontSize: '1.1rem' }}>{I18n.t('auth.resetPassword.instructions')}</p>

            <PasswordFieldContainer
                value={password.value}
                label={I18n.t('password')}
                handleFieldChange={value => handlePasswordDataChanged(value, "password")}
                handleFieldBlur={() => handleFieldBlur("password")}
                themeName="form"
                error={password.error}
                width={12}
            />

            <PasswordFieldContainer
                value={repeatPassword.value}
                label={I18n.t('repeatPassword')}
                handleFieldChange={value => handlePasswordDataChanged(value, "repeatPassword")}
                handleFieldBlur={() => handleFieldBlur("repeatPassword")}
                themeName="form"
                error={repeatPassword.error}
                width={12}
            />

            <p style={{ marginBottom: '2vh' }} />
            <button
                className={(disabled ? "btn btn-lg btn-outline-secondary" : "btn btn-primary ") + " d-block mx-auto w-50"}
                style={{ fontSize: "1.3rem" }}
                disabled={disabled}
                onClick={handleSubmit}>
                {I18n.t('auth.resetPassword.button')}
            </button>
            <img
                className="img-fluid d-block mx-auto"
                style={{ marginTop: '6vh' }}
                alt="back"
                src={forwardButtonImg}
                onClick={() => handleCollapseResetPasswordClicked(false)}
            />
        </div>
    </div>
}

ResetPassword.propTypes = {
    email: PropTypes.shape({
        value: PropTypes.string.isRequired,
        error: PropTypes.string
    }),
    handleCollapseResetPasswordClicked: PropTypes.func,
    handlePasswordDataChanged: PropTypes.func.isRequired,
    handleFieldBlur: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool
}

export default ResetPassword;
